<div class="notification-container" [ngClass]="type">
    <img [src]="getIconPath()" alt="{{ type }} icon" width="24" height="24">
    <span class="notification-text">{{ message }}</span>
  </div>